import { QueryClient } from '@tanstack/react-query';

// Single shared query client for the whole app. Import this anywhere you need to
// invalidate/refetch after a mutation, e.g. queryClient.invalidateQueries({ queryKey: ['shipments'] }).
//
// Defaults are intentionally conservative: several backend endpoints are capacity-limited
// (see DDB packets throttling), so we avoid aggressive background refetching. Tune per-query
// with `staleTime`/`refetchInterval` where a screen genuinely needs fresher data.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // treat data as fresh for 30s -> no duplicate refetch storms
      retry: 1, // one retry on failure, then surface the error
      refetchOnWindowFocus: false, // opt-in per query instead of app-wide, to protect the API
    },
  },
});

export default queryClient;
